var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 16.1299 1.55938 18.174 2.93443 19.3199C3.63671 19.9051 4.64335 20.3354 6.13814 20.6123C7.63548 20.8896 9.54819 21 12 21C14.4518 21 16.3645 20.8896 17.8619 20.6123C19.3566 20.3354 20.3633 19.9051 21.0656 19.3199C22.4406 18.174 23 16.1299 23 12C23 7.87011 22.4406 5.82597 21.0656 4.6801C20.3633 4.09487 19.3566 3.66457 17.8619 3.38773C16.3645 3.11042 14.4518 3 12 3C9.54819 3 7.63548 3.11042 6.13814 3.38773C4.64335 3.66457 3.63671 4.09487 2.93443 4.6801C1.55938 5.82597 1 7.87011 1 12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9C5 10.2524 5.18548 10.5519 5.31995 10.6672C5.39731 10.7335 5.55813 10.8266 5.9243 10.8963C6.29423 10.9668 6.7987 11 7.5 11C8.2013 11 8.70577 10.9668 9.0757 10.8963C9.44187 10.8266 9.60269 10.7335 9.68005 10.6672C9.81452 10.5519 10 10.2524 10 9C10 7.74763 9.81452 7.44807 9.68005 7.33282C9.60269 7.26651 9.44187 7.17342 9.0757 7.10367C8.70577 7.0332 8.2013 7 7.5 7C6.7987 7 6.29423 7.0332 5.9243 7.10367C5.55813 7.17342 5.39731 7.26651 5.31995 7.33282C5.18548 7.44807 5 7.74763 5 9Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H19M12 16H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.992fa614b34bd8994aae04d31474951d.svg";
export { ForwardRef as ReactComponent };